﻿CONFIG = {
	"backendUrl": process.env.apiUrl
}